import { AfterViewInit, Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
    selector: 'app-evaluation-slider',
    templateUrl: './evaluation-slider.component.html',
    styleUrls: ['./evaluation-slider.component.scss'],
    standalone: false
})
export class EvaluationSliderComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit() {
  }


  ngAfterViewInit() {
    $('#carouselExampleCaptions').carousel();
  };

}
